import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import Counter from '../Counter';
import { IBindingCallback1 } from '../../common/models/callback';
import { IRefReqCounters } from '../../common/models/referenceRequest/IRefReqCounters';
import styles from './styles.module.scss';

interface IProps {
  onChange: IBindingCallback1<number>;
  onDisable?: IBindingCallback1<keyof IRefReqCounters>;
  disabled?: boolean;
  prefix: keyof IRefReqCounters;
  value: number;
}

const Step3CounterItem: FunctionComponent<IProps> = ({ prefix, value, disabled, onChange }) => (
  <div className={`${styles.counterItem} ${disabled ? styles.disabled : ''}`}>
    <div className={styles.itemHeader}><FormattedMessage id={`step3.title.${prefix}`} /></div>
    <div className={styles.itemDescription}><FormattedMessage id={`step3.description.${prefix}`} /></div>
    <div className={styles.counter}>
      <Counter
        value={value}
        onChange={onChange}
        disablePlus={disabled}
        disableMinus={disabled}
      />
    </div>
  </div>
);

export default Step3CounterItem;
